'use client';

import type { ReactNode } from 'react';
import { Box } from '@terra/ui-styled-system';

type InternalNetworkGraphPopoverCardProps = {
  children: ReactNode;
  width?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  onContextMenu?: (event: React.MouseEvent<HTMLDivElement>) => void;
};

export function InternalNetworkGraphPopoverCard({
  children,
  width = '240px',
  onClick,
  onContextMenu,
}: InternalNetworkGraphPopoverCardProps) {
  return (
    <Box
      className="nodrag nowheel"
      w={width}
      backgroundColor="bg.default"
      borderWidth="1px"
      borderColor="border.neutral.subtle"
      borderRadius="md"
      boxShadow="sm"
      onClick={onClick}
      onContextMenu={onContextMenu}
    >
      {children}
    </Box>
  );
}
